var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.change($event)}}},[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.list),function(item){return _c('el-tab-pane',{key:item.value,attrs:{"label":item.label,"name":item.value}},[_vm._t(("tab_" + (item.value)))],2)}),1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/TabsBox/TabsBox.vue